import React from "react";
import { Check, Star, MailCheck } from "lucide-react";
import { plans } from "../mock";
import { Button } from "./ui/button";

const Pricing = ({ onChoose }) => {
  return (
    <section id="pricing" className="py-24 bg-[#0a101e]">
      <div className="max-w-7xl mx-auto px-5">
        <div className="text-center mb-16">
          <h2 className="font-pixel pixel-white text-2xl sm:text-3xl lg:text-4xl">
            CHOOSE YOUR PLAN
          </h2>
          <p className="text-slate-400 text-lg max-w-2xl mx-auto mt-5">
            Select a time-based access license. Every plan unlocks the full Rips toolkit with instant email delivery.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-7 items-stretch">
          {plans.map((p) => (
            <div
              key={p.id}
              className={`card-hover relative rounded-2xl border bg-[#0f1a30] p-6 flex flex-col ${
                p.popular
                  ? "border-yellow-400/60 glow-yellow lg:scale-[1.03]"
                  : "border-white/8"
              }`}
            >
              {p.popular ? (
                <div className="flex items-center gap-2 bg-gradient-to-r from-red-500 to-red-600 text-white rounded-full px-4 py-2 mb-5 self-start">
                  <Star className="w-4 h-4 fill-white" />
                  <span className="text-xs tracking-widest font-semibold">{p.tag}</span>
                </div>
              ) : (
                <div className="bg-white/5 border border-white/8 rounded-full px-4 py-2 mb-5 text-center">
                  <span className="text-xs tracking-widest text-slate-300 font-semibold">{p.tag}</span>
                </div>
              )}

              <h3 className="font-pixel pixel-white text-lg sm:text-xl mt-1">{p.name}</h3>

              <div className="mt-5 flex items-end gap-1">
                <span className="font-pixel pixel-gold text-4xl sm:text-5xl">${p.price}</span>
              </div>

              <div className="mt-5 flex items-center gap-2 bg-gradient-to-r from-green-600 to-green-500 text-white rounded-lg px-4 py-3">
                <MailCheck className="w-4 h-4" />
                <span className="text-sm font-medium">{p.delivery}</span>
              </div>

              <ul className="mt-6 space-y-3 flex-1">
                {p.features.map((f, i) => (
                  <li key={i} className="flex items-start gap-3 text-slate-200">
                    <span className="mt-0.5 w-5 h-5 rounded-full bg-yellow-400/15 border border-yellow-400/40 flex items-center justify-center shrink-0">
                      <Check className="w-3 h-3 text-yellow-400" />
                    </span>
                    <span className="text-sm">{f}</span>
                  </li>
                ))}
              </ul>

              <Button
                onClick={() => onChoose(p)}
                className={`mt-7 h-12 rounded-lg font-semibold text-base ${
                  p.popular
                    ? "bg-yellow-400 hover:bg-yellow-300 text-[#0a101e] glow-yellow"
                    : "bg-[#16223d] hover:bg-[#1c2c4f] text-yellow-400 border border-yellow-400/40"
                }`}
              >
                Choose Plan
              </Button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Pricing;
